var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 69,
    viewBox: "0 0 75 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6213 6.77119C37.7155 7.10821 36.6288 7.82129 36.0068 8.22329C33.603 9.77672 2.4414 30.6522 2.4414 30.6522C2.4414 30.6522 -1.6428 32.9565 0.753841 36.3775C3.15048 39.7986 6.84531 37.0025 6.84531 37.0025C6.84531 37.0025 35.6272 17.7015 36.6071 17.1026C37.6079 16.4909 38.9529 15.8741 40.5137 15.8741C42.0745 15.8741 43.6516 16.7215 44.6504 17.5543C45.6493 18.3872 55.0255 25.96 58.7452 28.8483C58.8378 28.9202 60.7478 30.3692 63.1014 30.1158C65.3737 29.871 66.8607 28.4557 66.9084 28.4085C66.956 28.3613 68.998 26.3361 69.9507 25.3788C70.2568 25.0713 70.716 24.9325 71.1379 25.2278C71.3479 25.3747 72.0868 26.0012 72.2336 26.0918C72.6162 26.3281 73.1804 26.3916 73.655 25.9705C74.2049 25.4825 74.1484 24.6395 74.2092 24.3793C74.3289 23.8667 74.8864 18.1499 74.932 17.6584C74.977 17.1745 75.0154 16.6256 74.9938 16.4638C74.9655 16.2521 74.7061 15.9405 74.3694 15.8953C74.2009 15.8727 73.9183 15.8451 73.3508 15.8868C72.8749 15.9219 66.6093 16.5096 66.6093 16.5096C66.6093 16.5096 65.0863 16.6438 64.7179 17.2183C64.4061 17.7046 64.4229 18.2731 64.9549 18.8527C65.487 19.4322 65.6608 19.7004 65.6608 19.7004C65.6608 19.7004 66.0146 20.1762 65.4942 20.7306C64.853 21.4136 64.1362 22.1104 63.7887 22.2637C63.4411 22.417 62.4464 22.3304 61.8097 21.9579C61.1732 21.5854 44.3016 7.95009 44.3016 7.95009C44.3016 7.95009 43.0191 6.97257 41.8878 6.70528C41.8878 6.70528 40.2609 6.16107 38.6213 6.77119Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2243 2.00149e-06C20.5389 0.00294554 20.1792 4.04421 20.1792 4.04421C20.1792 4.04421 20.1792 6.87174 20.1792 9.1364C20.1792 11.4724 20.0101 11.6916 21.0545 12.4534C22.3764 13.2941 23.9671 12.3271 24.5404 12.0345C25.2978 11.6479 26.7719 10.589 27.269 10.2513C28.0781 9.70127 28.2581 9.07625 28.3456 8.27034C28.4777 7.05573 28.3997 4.03657 28.3997 4.03657C28.3997 4.03657 28.3365 -0.00328233 24.2243 2.00149e-06Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5559 38.6785C7.87039 38.6854 7.41999 42.2882 7.41999 42.7528C7.41999 43.2174 7.41999 64.7909 7.41999 65.2035C7.41999 65.6159 7.42223 69.0379 11.3073 68.9996C15.5627 68.9578 15.6497 65.6159 15.6578 65.1947C15.666 64.7735 15.6497 43.2174 15.6606 42.7528C15.6714 42.2882 15.668 38.6709 11.5559 38.6785Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5894 29.6175C20.9039 29.6265 20.49 33.1537 20.4486 33.5353C20.407 33.9169 20.407 64.9059 20.407 65.2309C20.407 65.556 20.4593 69.0492 24.3443 68.9995C28.5997 68.9451 28.6275 65.5218 28.6275 65.1976C28.6275 64.8734 28.6275 33.9169 28.6275 33.5554C28.6275 33.1939 28.7016 29.6075 24.5894 29.6175Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5175 38.6785C46.832 38.6854 46.3044 42.2364 46.3044 42.7401C46.3044 43.2439 46.3044 65.0791 46.3044 65.3656C46.3044 65.6521 46.3839 69.0379 50.2689 68.9996C54.5243 68.9578 54.6364 65.6137 54.6364 65.3037C54.6364 64.9937 54.6364 43.2439 54.6194 42.7696C54.6026 42.2954 54.6297 38.6708 50.5175 38.6785Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4044 33.418C59.7189 33.4261 59.3408 36.9633 59.3273 37.4537C59.3138 37.9441 59.3138 64.9957 59.3138 65.3398C59.3138 65.6838 59.2707 69.0444 63.1558 68.9995C67.4112 68.9504 67.5801 65.6037 67.5801 65.3292V37.4584C67.5801 36.9728 67.5165 33.409 63.4044 33.418Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.67 21.0218C33.9846 20.9994 33.3811 24.2307 33.3643 24.9116C33.3474 25.5924 33.3643 64.7083 33.3643 65.0223C33.3643 65.3364 33.2968 69.0267 37.1821 68.9999C41.4376 68.9704 41.6309 65.2469 41.6309 64.9671C41.6309 64.6873 41.5575 24.8455 41.5575 24.8455C41.5575 24.8455 41.7822 21.0469 37.67 21.0218Z",
    fill: "url(#paint6_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -18.2143,
    y1: 6.65357,
    x2: -16.6271,
    y2: 69.0073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E7BFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -18.2143,
    y1: 6.65357,
    x2: -16.6271,
    y2: 69.0073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E7BFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: -18.2143,
    y1: 6.65357,
    x2: -16.6271,
    y2: 69.0073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E7BFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: -18.2143,
    y1: 6.65357,
    x2: -16.6271,
    y2: 69.0073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E7BFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: -18.2143,
    y1: 6.65357,
    x2: -16.6271,
    y2: 69.0073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E7BFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: -18.2143,
    y1: 6.65357,
    x2: -16.6271,
    y2: 69.0073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E7BFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: -18.2143,
    y1: 6.65357,
    x2: -16.6271,
    y2: 69.0073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E7BFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600CC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.48f23953.svg";
export { ForwardRef as ReactComponent };